import { SET_BULK_PAYMENT, CLEAR_PARAMS_PAYMENT, SET_PARAMS_PAYMENT } from "constants/types";


const initialState = {
    search: "",
    page: 1,
    size: 10,
    status: "",
    composer_id: "",
    startDate: "",
    endDate: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_PAYMENT:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PAYMENT:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_PAYMENT:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
